import { render } from "./FiltrosFacturas.vue?vue&type=template&id=407017f7&scoped=true"
import script from "./FiltrosFacturas.vue?vue&type=script&lang=js"
export * from "./FiltrosFacturas.vue?vue&type=script&lang=js"

import "./FiltrosFacturas.vue?vue&type=style&index=0&id=407017f7&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407017f7"]])

export default __exports__